<template>
  <div class="upload_div">

    <Upload action=""
    list-type="picture-card"
    :file-list="fileList"
    :limit = "limit"
    :http-request="uploadattached" :on-preview="handlePictureCardPreview"
      :before-upload="beforeAvatarUpload"
      :on-success="handleAvatarSuccess"
       :on-remove="handleRemove"
       :on-exceed="handelExceed"  :disabled="disabledStatus==='true'">
      <i class="el-icon-plus"></i>
    </Upload>

    <!--
    <el-upload class="avatar-uploader"
    action="http://"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :http-request="uploadattached"
      :disabled="disabledStatus==='true'">
      <img v-if="realImgUrl" :src="realImgUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload> -->

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->

  </div>
</template>
<script>
  import {
    Upload
  } from 'element-ui';
  import {
    uploadtoken,
    upload
  } from '@/api/file.js'
  import config from '@/config/index';
  export default {
    data() {
      return {
        fname: "",
        realImgUrl: "",
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: []
      };
    },
    components: {
      Upload
    },
    props: ["imageName", "disabledStatus","limit"],
    methods: {
      handleRemove(file, fileList) {
        console.log(file, fileList);
        this.fileList = fileList;
        this.emitFileList()
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleAvatarSuccess(res, file) {
        console.log("call handleAvatarSuccess");
        this.realImgUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        console.log("call beforeAvatarUpload");
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'|| file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG或PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      handelExceed(){
         this.$message.error('只允许上传' + this.limit  +  "张图片");
      },
      uploadattached: function(request) {
        this.upLoader(request)
      },
      upLoader(request) {
        console.log("call uploader..")
        this.fname = request.file.uid + request.file.name;
        console.log(this.fname);
        var that = this;
        uploadtoken({
          "filename": this.fname
        }).then(res => {
          let token = res.data;
          console.log("请求" + JSON.stringify(request))
          upload(
            this.fname,
            token,
            request,
            next => {
              let total = next.total;
              console.log(total);
            },
            error => {
              console.log(error)
            },
            complete => {
              let hash = complete.hash;
              let key = complete.key;
              var files = []
              this.fileList.push({
                  "name": this.fname,
                  "url": `${config.HOST_IMG }${this.fname}`
                })
              this.emitFileList()
            }
          )
        });
      },
      emitFileList(){
        var files = []
        console.log("emit fileslist");

        for (var i = 0; i < this.fileList.length; i++) {
          files.push( this.fileList[i].name);
        };

        console.log(files);

        this.$emit('resetImageName', files)
      },
      initFileList() {
        console.log("watch imageName= ");
        console.log(this.imageName);
        var fileList = [];
        try {
          var tmpFileList = JSON.parse(this.imageName)
          for (var i = 0; i < tmpFileList.length; i++) {
            fileList.push({
              "name": tmpFileList[i],
              "url": `${config.HOST_IMG }${tmpFileList[i]}`
            })
          }
        } catch (e) {
          console.log(e);
        }
        console.log( "fileList = ");
        console.log(fileList);
        this.fileList = fileList;
      }
    },
    watch: {
      imageName(value) {
        console.log('call watch imagename');
        console.log(value);
        this.initFileList();
      },
      limit(value){
          this.limit = value
      }
    },
    mounted() {
      // if (this.imageName && this.imageName.length > 0) {
      //   this.realImgUrl = HTTP_BASE_IMG + "/" + this.imageName
      // }
      this.initFileList();
    },


  }
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
